import * as getters from "../../baseQuestion/searchableStaticDDL/store/getters";
import * as mutations from "../../baseQuestion/searchableStaticDDL/store/mutations";
import * as actions from "../../baseQuestion/searchableStaticDDL/store/actions";
import { state as base_state } from "../../baseQuestion/searchableStaticDDL/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_community",
			options: [
				{
					value: "VOL006",
					text: "Americorp/Vista"
				},
				{
					value: "VOL001",
					text: "Civic"
				},
				{
					value: "VOL003",
					text: "Education"
				},
				{
					value: "VOL002",
					text: "Health Care"
				},
				{
					value: "EMP009",
					text: "Jobs for Maine's Graduates"
				},
				{
					value: "VOL999",
					text: "Other - Volunteer"
				},
				{
					value: "VOL007",
					text: "Peace Corps"
				},
				{
					value: "VOL009",
					text: "Peer Mentor"
				},
				{
					value: "VOL005",
					text: "Religious"
				},
				{
					value: "VOL004",
					text: "Social Services"
				},
				{
					value: "VOL008",
					text: "Tutor"
				}
			]
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
